import { TFunction } from 'i18next'

import { MODES } from './SalesGoalWidget.constant'

export const getDateRangeOptions = (t: TFunction) => [
  {
    label: t('weekMonthSelector.week'),
    value: MODES.week
  },
  {
    label: t('weekMonthSelector.month'),
    value: MODES.month
  }
]
